<div>
  <span *ngFor="let breadcrumb of breadcrumbs; let i = index">
    <p
      class="breadcrumb"
      (click)="redirect(breadcrumb.url, breadcrumb.params)"
      [ngClass]="{ link: breadcrumb.url }">
      {{ breadcrumb.label }}
    </p>
    <span *ngIf="i < breadcrumbs.length - 1">{{ ' • ' }}</span>
  </span>
</div>
